import { consultationConsultationEntitySchemaV1, design_systemUiEventEventSchemaV1, experimentationFeatureFlagsEntitySchemaV1, pmsPrescriptionProductEntitySchemaV2, } from '../__generated__';
/**
 * Registering a new analytics context:
 *
 * 1. Import the schema from `'lib/__generated__`
 * 2. Add the schema to the `contextSchemas` object below.
 *    - The key you use here (e.g., `consultation`, `flags`) will be used when referencing this context
 *      inside `AnalyticsTrackingProvider` and emitted events.
 *
 * Example:
 * ```ts
 * import { myCustomContextEntitySchemaV1 } from ''lib/__generated__';
 *
 * export const contextSchemas = {
 *   ...,
 *   myContextKey: myCustomContextEntitySchemaV1
 * } as const;
 * ```
 *
 * The `TypedAnalyticsContexts` type infers the correct structure
 * based on your schema.
 */
export const contextSchemas = {
    consultation: consultationConsultationEntitySchemaV1,
    flags: experimentationFeatureFlagsEntitySchemaV1,
    uiEvent: design_systemUiEventEventSchemaV1.pick({ context_id: true }),
    prescriptionProduct: pmsPrescriptionProductEntitySchemaV2,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5hbHl0aWNzLWNvbnRleHRzLnR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb250ZXh0L2FuYWx5dGljcy1jb250ZXh0cy50eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQ0wsc0NBQXNDLEVBQ3RDLGlDQUFpQyxFQUNqQyx5Q0FBeUMsRUFDekMsb0NBQW9DLEdBQ3JDLE1BQU0sa0JBQWtCLENBQUM7QUFFMUI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBb0JHO0FBRUgsTUFBTSxDQUFDLE1BQU0sY0FBYyxHQUFHO0lBQzVCLFlBQVksRUFBRSxzQ0FBc0M7SUFDcEQsS0FBSyxFQUFFLHlDQUF5QztJQUNoRCxPQUFPLEVBQUUsaUNBQWlDLENBQUMsSUFBSSxDQUFDLEVBQUUsVUFBVSxFQUFFLElBQUksRUFBRSxDQUFDO0lBQ3JFLG1CQUFtQixFQUFFLG9DQUFvQztDQUNqRCxDQUFDIn0=